import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment-timezone';
import { FormArray, FormGroup, NgForm, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { customEmailValidator } from '../../core/utils/custom-email-validator.utils';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { prohibitedCharactersValidator } from '../../core/utils/validators/prohibited-characters.valdator';

@UntilDestroy()
@Component({
  selector: 'app-residential-insured-details',
  templateUrl: './residential-insured-details.component.html',
  styleUrls: ['./residential-insured-details.component.scss']
})
export class ResidentialInsuredDetailsComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() index;
  @Input() totalAdditionalInsured;
  @Output() removeInsured = new EventEmitter();
  @Output() spouseChanged = new EventEmitter();
  @Output() leadDataChanged = new EventEmitter();
  maxBirthdayDate;
  subscription = new Subscription();

  constructor() {
    this.maxBirthdayDate = moment(moment.now()).subtract(18, 'year').toDate();
  }

  ngOnInit() {
    this.toggleValidators(this.form.value);
    this.onAdditionalInsuredChanges();
  }

  onAdditionalInsuredChanges() {
    this.subscription.add(
      this.form.valueChanges.subscribe(user => {
        this.toggleValidators(user);
      })
    )
  }

  toggleValidators(user) {
    if (this.isNotEmptyUser(user)) {
      this.setValidators();
    } else {
      this.clearValidators();
    }
  }

  setValidators() {
    this.form.get('first_name').addValidators([Validators.required, Validators.maxLength(30), prohibitedCharactersValidator()]);
    this.form.get('last_name').addValidators([Validators.required, Validators.maxLength(30), prohibitedCharactersValidator()]);
    this.form.get('contact_phone').addValidators([Validators.required]);
    this.form.get('birth_date_sub').addValidators([Validators.required]);
    this.form.get('email').addValidators([Validators.required, customEmailValidator()]);
    this.updateValueAndValidity();
  }

  updateValueAndValidity() {
    this.form.get('first_name').updateValueAndValidity({ emitEvent: false });
    this.form.get('last_name').updateValueAndValidity({ emitEvent: false });
    this.form.get('contact_phone').updateValueAndValidity({ emitEvent: false });
    this.form.get('birth_date_sub').updateValueAndValidity({ emitEvent: false });
    this.form.get('email').updateValueAndValidity({ emitEvent: false });
  }

  clearValidators() {
    this.form.get('first_name').clearValidators();
    this.form.get('last_name').clearValidators();
    this.form.get('contact_phone').clearValidators();
    this.form.get('birth_date_sub').clearValidators();
    this.form.get('email').clearValidators();
    this.form.reset({}, { emitEvent: false });
    this.form.get('spouse').reset(false, { emitEvent: false });
  }

  isNotEmptyUser(user) {
    const found = Object.keys(user).find(key => user[key]);
    return !!found;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  createResidentialLead(v) {
    this.leadDataChanged.emit(v);
  }

  onRemoveInsured($event) {
    this.removeInsured.emit();
  }

  get f() {
    return this.form.controls;
  }
}
